import type { FormContext } from '#types/components/base/form'
import type { InjectionKey } from 'vue'

export const FormContextKey: InjectionKey<FormContext> = Symbol('FormContext')
